import { Link } from 'react-router-dom';
import Cookies from 'js-cookie';
import { icons } from '../../../constants/icons';
import { removeCourseFromCart } from '../../Utils/helper';
import { getAuthDataCall } from '../../services/utils';

export function printcartData(
    cartArr,
    helperProps,
    history,
    customData = {
        free: 'Free',
    }
) {
    // cart items carry no country_id, so the caller passes the user's country
    const { countryId } = customData;
    return (
        <>
            {cartArr?.map((_cart) => {
                return !_cart?.parent_name ? (
                    <a className="cart_row cursor_pointer">
                        <div className="cart_img">
                            <img src={'https://www.admin.dawratycourses.com' + _cart?.image} alt="course_image" />
                        </div>
                        <div className="cart_course_details">
                            <div className="cart_course_title">{_cart?.name}</div>
                            <div className="cart_course_instructor">{_cart?.instructor_name || ''}</div>
                            <div className="cp_wrapper">
                                {_cart?.is_free ? (
                                    <div className="price_discount">{customData.free}</div>
                                ) : (
                                    <div className="price_discount">
                                        {countryId === 112
                                            ? helperProps.t('course.price_in_kd', {
                                                  price: _cart?.price,
                                              })
                                            : countryId === 17
                                              ? helperProps.t('course.price_in_bd', {
                                                    price: _cart?.price,
                                                })
                                              : helperProps.t('course.price_in_jd', {
                                                    price: _cart?.price,
                                                })}
                                    </div>
                                )}
                            </div>
                        </div>
                        <button
                            type="button"
                            className="cart-item-remove-btn"
                            onClick={() =>
                                removeCourseFromCart(_cart, helperProps, 'cart-loading', history, {
                                    removeFromCart: customData.removeCourseFromCart,
                                })
                            }
                        >
                            <img src={icons.icon_close} alt="close" />
                        </button>
                    </a>
                ) : (
                    <a className="cart_row cursor_pointer">
                        <div className="cart_img">
                            <img
                                src={'https://www.admin.dawratycourses.com' + _cart?.parent_image}
                                alt="course_image"
                            />
                        </div>
                        <div className="cart_course_details">
                            <div className="cart_course_title">{_cart?.name}</div>
                            <div className="cart_course_title">{_cart?.parent_name}</div>
                            <div className="cp_wrapper">
                                <div className="price_discount">
                                    {countryId === 112
                                        ? helperProps.t('course.price_in_kd', {
                                              price: _cart?.price,
                                          })
                                        : countryId === 17
                                          ? helperProps.t('course.price_in_bd', {
                                                price: _cart?.price,
                                            })
                                          : helperProps.t('course.price_in_jd', {
                                                price: _cart?.price,
                                            })}
                                </div>
                            </div>
                        </div>
                        <button
                            type="button"
                            className="cart-item-remove-btn"
                            onClick={() =>
                                removeCourseFromCart(_cart, helperProps, 'cart-loading', history, {
                                    removeFromCart: customData.removeCourseFromCart,
                                })
                            }
                        >
                            <img src={icons.icon_close} alt="close" />
                        </button>
                    </a>
                );
            })}
        </>
    );
}

let abortController;

export const handleSearchChange = async (e, setSearchCourseData, loggedIn, countryId, setLoadingSearch) => {
    const searchTerm = e.target.value;
    setLoadingSearch(true);

    if (abortController) {
        abortController.abort();
    }

    abortController = new AbortController();

    try {
        if (!countryId) {
            console.warn('No country ID available for search');
            setLoadingSearch(false);
            setSearchCourseData([]);
            return;
        }

        const results = await getAuthDataCall(
            `/v1/courses?search=${encodeURIComponent(searchTerm)}&country_id=${Number(countryId)}`,
            {
                signal: abortController.signal,
            }
        );

        setLoadingSearch(false);

        if (!searchTerm || searchTerm.trim() === '') {
            setSearchCourseData(null);
            return;
        }

        // TODO(aalhendi): hack until responses are standardized
        const searchResults = results?.data?.data || results?.data?.data?.data || [];
        setSearchCourseData(searchResults);
    } catch (error) {
        setLoadingSearch(false);
        if (error.name !== 'AbortError') {
            console.error('Search error:', error);
            setSearchCourseData([]);
        }
    }
};

export function logoutUser() {
    Cookies.remove('EAPISID');
    Cookies.remove('auth');
    <Link to="/" />;
}
